/**
 * Component to emulate slots behavior
 *
 * HOW TO USE:
 *
 *  1- import slotsUtils from '@elab/core/utils/ui/slotsUtils';
 *  2- Add "emulate-slot" css class to v-slot element;
 *  3- firstUpdated() {
 *          slotsUtils.emulateSlots(this, true)
 *     }
 *  - The 2nd param (true) allow us to clone the node
 *
 * WARNING: Use this util only if really needed. It could affect site performance.
 *
 */

const emulateSlots = (component, cloned) => {
    const emulateSlotHandler = e => {
        const slot = e.target;
        let lightDomContent =
            component && slot && component.querySelector(`[v-slot="${slot.name}"]`);
        if (cloned && lightDomContent) {
            lightDomContent = lightDomContent.cloneNode(true);
        }
        const vSlotContent = slot && slot.querySelector('v-slot-assigned-content');
        lightDomContent &&
            vSlotContent &&
            vSlotContent.classList.contains('v-slot__assigned-content--hidden') &&
            vSlotContent.append(lightDomContent) &&
            vSlotContent.classList.remove('v-slot__assigned-content--hidden');
    };
    component &&
        [...component.querySelectorAll('v-slot.emulate-slot')].map(slot => {
            slot.addEventListener('v::slotchange', emulateSlotHandler);
        });
};

export default {
    emulateSlots,
};
